import { render, staticRenderFns } from "./MaxActiveTopicsReachedAlert.vue?vue&type=template&id=24470656&"
import script from "./MaxActiveTopicsReachedAlert.vue?vue&type=script&lang=js&"
export * from "./MaxActiveTopicsReachedAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports